import { isEqual } from 'lodash'

export default ({ from, route, store, redirect }) => {
  // Prevent features check on query params changes on the same route
  if (
    from.name !== route.name ||
    (from.name === route.name && isEqual(from.query, route.query))
  ) {
    const currentRouteMeta = (route.meta != null)
      ? route.meta.slice(-1)[0]
      : null

    const feature = (currentRouteMeta != null)
      ? currentRouteMeta.feature
      : null

    const disabledFeatures = store.getters['features/disabledFeatures']

    if (disabledFeatures.includes(feature)) {
      redirect({ name: 'dashboard' })
    }
  }
}
